export default __webpack_public_path__ + "media/zurb/img/bryan/bryan-64f251fd291dfaf103d778f4d3914b40.jpg";